var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4706 5.46967C12.7635 5.17678 13.2384 5.17678 13.5313 5.46967L19.5313 11.4697C19.672 11.6103 19.751 11.8011 19.751 12C19.751 12.1989 19.672 12.3897 19.5313 12.5303L13.5313 18.5303C13.2384 18.8232 12.7635 18.8232 12.4706 18.5303C12.1778 18.2374 12.1778 17.7626 12.4706 17.4697L17.1903 12.75H5.00098C4.58676 12.75 4.25098 12.4142 4.25098 12C4.25098 11.5858 4.58676 11.25 5.00098 11.25H17.1903L12.4706 6.53033C12.1778 6.23744 12.1778 5.76256 12.4706 5.46967Z",
    fill: "currentColor"
  })));
};
export default SvgArrowRight;